import type { PLAAttributeDefinition } from "./PLAState";

export function getSortedPLAAttributeEntries(attributes: Record<string, PLAAttributeDefinition> | undefined): [string, PLAAttributeDefinition][] {
   return Object.entries(attributes || {})
      .map(([attributeId, definition], index) => ({ attributeId, definition, index }))
      .sort((a, b) => {
         const aSortOrder = typeof a.definition.sortOrder === "number" && Number.isFinite(a.definition.sortOrder) ? a.definition.sortOrder : undefined;
         const bSortOrder = typeof b.definition.sortOrder === "number" && Number.isFinite(b.definition.sortOrder) ? b.definition.sortOrder : undefined;
         if (aSortOrder !== undefined && bSortOrder !== undefined && aSortOrder !== bSortOrder) return aSortOrder - bSortOrder;
         if (aSortOrder !== undefined && bSortOrder === undefined) return -1;
         if (aSortOrder === undefined && bSortOrder !== undefined) return 1;
         return a.index - b.index;
      })
      .map(({ attributeId, definition }) => [attributeId, definition]);
}